import React from "react";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSCardHeader from "views/system-design/DSCardHeader";
import DSTypography from "views/system-design/DSTypography";
import DSChip from "views/system-design/DSChip";
import DSBox from "views/system-design/DSBox";
import type { DeviceInfo } from "../types";

interface DeviceCardProps {
  device: DeviceInfo;
}

/**
 * Card component displaying device information
 *
 * Shows device ID, model, connection status, and current firmware version.
 * Used in the Version Tester page to display all connected devices.
 */
const DeviceCard: React.FC<DeviceCardProps> = ({ device }) => {
  const isConnected = device.state === "device";

  return (
    <DSCard>
      <DSCardHeader title={device.id} subheader={device.model} />
      <DSCardContent>
        <DSBox sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <DSBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DSTypography variant="body2" color="text.secondary">
              Status:
            </DSTypography>
            <DSChip
              label={isConnected ? "Connected" : "Offline"}
              color={isConnected ? "success" : "error"}
              size="small"
            />
          </DSBox>

          <DSBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DSTypography variant="body2" color="text.secondary">
              Current Version:
            </DSTypography>
            <DSTypography variant="body2">
              {device.version || "Unknown"}
            </DSTypography>
          </DSBox>
        </DSBox>
      </DSCardContent>
    </DSCard>
  );
};

export default DeviceCard;
